import { AUTH } from "@core/utility/settings";
import StorageService from "@shared/services/storage.service";
import { differenceInSeconds, toDate } from "date-fns";
import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { LocalAuth } from "@core/model/local-auth";
import { appConfig } from "../../../app.config";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import { LocalRole } from "@core/model/local-role.enum";

interface ProtectedRouteProps {
  children: ReactNode;
}
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const user = StorageService.load<LocalAuth>(AUTH);
  const { getUserRole } = useUserIdentityContext();
  const userRole = getUserRole();
  const { pathname } = useLocation();

  const isPathAllowed = (allowedPaths: string[]) => {
    const segments = pathname.split("/").filter(Boolean);

    const isAllowed = segments.some((segment) =>
      allowedPaths.includes(segment)
    );

    return isAllowed;
  };

  if (!user) {
    return <Navigate to="/login" />;
  }

  const serverExpiry = toDate(user.accessExpiry * 1000);
  const currentDate = new Date();
  const diffInSec = differenceInSeconds(serverExpiry, currentDate);

  if (userRole?.name.toUpperCase() === LocalRole.Cashier) {
    const allowedPaths = ["booking"];
    const isAllowed = isPathAllowed(allowedPaths);
    if (!isAllowed) {
      return <Navigate to="/business/booking" />;
    }
  }

  if (diffInSec < appConfig.maxTimeForTimeout) {
    return <Navigate to="/login" />;
  }

  return <div>{children}</div>;
}
